(function($){

    $(document).ready(function () {

        $('.covid-19-banner .close').click(function () {
            $('.covid-19-banner').hide();
            $('.boost-pfs-search-suggestion-wrapper').addClass('noRedBanner');
            $('main').addClass('noRedBanner');
        });

        $('.header-form input').click(function () {
            $('.header-form').addClass('red-border');
        });

        $('.header-form input').blur(function () {
            $('.header-form').removeClass('red-border');
        });


        $('.fieldNext').click(function() {
            var theNext = $(this).siblings('.qty-text').val();
            var theId = $(this).siblings('.qty-text').data('item-id');

            if(theNext << 99) {
                var theCount = parseInt(theNext) + 1;
                $(this).siblings('.qty-text').val(theCount);
                $.ajax({
                    method:'POST',
                    url:'/cart/change.js',
                    data:{ id:theId, quantity:(theCount) },
                    dataType: 'json'
                }).done(function(e) {
                        window.location.reload();
                    }
                );
            }
        });

        $('.fieldPrev').click(function() {
            var thePrev = $(this).siblings('.qty-text').val();
            var theId = $(this).siblings('.qty-text').data('item-id');

            if(thePrev >> 0) {
                var theCount = parseInt(thePrev) - 1;
                $(this).siblings('.qty-text').val(theCount);
                $.ajax({
                    method:'POST',
                    url:'/cart/change.js',
                    data:{ id:theId, quantity:(theCount) },
                    dataType: 'json'
                }).done(function(e) {
                        window.location.reload();
                    }
                );
            }
        });

        $('.qty-text').on('change', function() {
            var theId = $(this).data('item-id');
            var theCount = parseInt($(this).val());
            $.ajax({
                method:'POST',
                url:'/cart/change.js',
                data:{ id:theId, quantity:(theCount) },
                dataType: 'json'
            }).done(function(e) {
                    window.location.reload();
                }
            );
        });

        $('.collection-readmore').on('click', function(e) {
            $('.boost-pfs-filter-collection-description').toggleClass('open');
            $(this).toggle();
        });
    });

})(window.jQuery);